// extracted by mini-css-extract-plugin
module.exports = {"Editorial":"Editorial--hI_zN"};